import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

const POIs = [
    {
        name: 'couplet-1',
        position: { x: -33, y: 22, z: 0 },
        color: 'white',
        sound: {
            name: 'couplet-1',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'couplet-2',
        position: { x: -35, y: 22, z: 0 },
        color: 'white',
        sound: {
            name: 'couplet-2',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'couplet-3',
        position: { x: -35, y: 24, z: 0 },
        color: 'white',
        sound: {
            name: 'couplet-3',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'couplet-4',
        position: { x: -33, y: 24, z: 0 },
        color: 'white',
        sound: {
            name: 'couplet-4',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'couplet-5',
        position: { x: -34, y: 23, z: 0 },
        color: 'white',
        sound: {
            name: 'couplet-5',
            gain: 0,
        },
        collision: {
            radius: 1,
        },
        onEnter() {
            triangle.drop('stonehenge-triangle-6', this.position, {
                collisionRadius: 0.5,
                offset: { x: -3, y: 3 },
                delay: 5,
                gain: 0,
            });
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'couplet-1', url: new URL('../../sound/Couplet1.wav', import.meta.url) },
    { name: 'couplet-2', url: new URL('../../sound/Couplet2.wav', import.meta.url) },
    { name: 'couplet-3', url: new URL('../../sound/Couplet3.wav', import.meta.url) },
    { name: 'couplet-4', url: new URL('../../sound/Couplet4.wav', import.meta.url) },
    { name: 'couplet-5', url: new URL('../../sound/Couplet5.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
